import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import AntragSchema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
import { BICValidation, IBANValidation, Required } from '../../../../../../../lib/validation/ValidationTypes';
const P = AntragSchema.attributes;

const KontoDaten: FC<{}> = () => {
    const { application, setApplicationProperty, printMode,readOnly } = useApplication();
    return (
        <>
            <ApplicationHeading title='Kontodaten' description={PLATZHALTER_TEXT} />

            <CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} printMode={printMode} />
        </>
    );
};

export default KontoDaten;

const formStruc = () => {
    let struc: FormStrucItem[] = [
        {
            fields: [
                {...P.Kontodaten_Kontoinhaber, validation: [{ validateFunction: Required }]},
                {...P.Kontodaten_IBAN, validation: [{ validateFunction: IBANValidation }, { validateFunction: Required }]},
            ],
            userProps: { columnToDivide: 2 },
        },
        {
            fields: [
                {...P.Kontodaten_Institut, validation: [{ validateFunction: Required }]},
                {...P.Kontodaten_BIC, validation: [{ validateFunction: BICValidation }, { validateFunction: Required }]},
            ],
            userProps: { columnToDivide: 2 },
        },
        {
            fields: [
                {...P.Kontodaten_Verwendungszweck, validation: [{ validateFunction: Required }]},
            ],
            userProps: { columnToDivide: 2 },
        },
    ];
    return struc;
};

export const getFormStrucKontoDaten = () => {
    return concat(formStruc());
};
